export const MapReducer = (state, action) => {
        switch (action.type) {
            case 'MAP_LOADED':
                return {
                    ...state,
                    map: action.map
                };
            case 'CHANGE_VIEW':
                return {
                    ...state,
                    config: {
                        ...state.config,
                        center: action.center,
                        zoom: {
                            ...state.config.zoom,
                            current: action.zoom,
                        }
                    },
                };
            case 'SELECT_DIVISION':
                return {
                    ...state,
                    divisionData: action.divisionData,
                };
            case 'SELECT_DOCKYARD':
                return {
                    ...state,
                    dockyardData: action.dockyardData,
                };
            case 'TOGGLE_LAYER_SWITCHER_DISPLAY':
                return {
                    ...state,
                    config: {
                        ...state.config,
                        layerSwitcherPanel: {
                            ...state.config.layerSwitcherPanel,
                            open: !state.config.layerSwitcherPanel.open || false
                        }
                    }
                };
            case 'TOGGLE_VISIBILITY_LAYER':
                return {
                    ...state,
                    config: {
                        ...state.config,
                        layerSwitcherPanel: {
                            ...state.config.layerSwitcherPanel,
                            layers: {
                                ...state.config.layerSwitcherPanel.layers,
                                ...action.layerVisivility
                            }
                        }
                    }
                };
            default:
                return state;
        }
    }
;